
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeOrcamento";
import InformacoesData from "../InformacoesData";
import { Money } from "v-money";
import { quantityOptions } from "@/modules/Application";

export default {
  name: "app-orcamento-form-informacoesTab",
  components: {
    VueSelect,
    Money,
  },
  directives: {
    mask,
  },
  data() {
    return {
      form: {},
      allStatus: [],
      status: null,
      keyToReRender: 0,
      store,
      statusError: false,
      enderecoError: false,
      statusFilled: false,
      quantityOptions,
      pesoEditado: false,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.form = new InformacoesData({});
      const { data } = await this.$http.post("/orcamento/status");
      this.allStatus = data;
      this.form.status = this.allStatus.find((item) => item.id === 1);
      this.form.validade = this.thisDate();
      this.form.validadeHour = this.thisTime();

      if (Object.keys(this.$route.params).length !== 0) {
        const { dataValidade, observacao, status, pesoLiquido, pesoBruto } =
          this.$route.params.orcamentoData;
        this.form.observacao = observacao;
        this.form.validade = dataValidade;
        this.form.validadeHour = dataValidade.split(" ")[1];
        this.form.status = this.allStatus.find((st) => st.id === status);
        this.form.pesoLiquido = pesoLiquido;
        this.form.pesoBruto = pesoBruto;
      }
    },
    setStatus(status) {
      this.form.status = status;
      this.statusFilled = true;
    },
    setValidadeHour(time) {
      this.form.validade = `${this.form.validade.split(" ")[0]} ${time}`;
      this.form.validadeHour = time;
    },
  },
  created() {
    this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === this.informacoesTabIndex;
    },
    informacoesTabIndex() {
      return store.apresentarObjetoIdentificador ? 4 : 3;
    },
    pesoTotal() {
      if (!store.formProduto || !store.formProduto.produtos) return 0;

      return store.formProduto.produtos.reduce(
        (total, produto) =>
          total + (produto.product.peso || 0) * (produto.quantity || 1),
        0
      );
    },
  },
  watch: {
    "store.form"(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.keyToReRender++;
      }
    },
    form(newValue) {
      this.store.formInformacoes = newValue;
    },
    pesoTotal(newValue) {
      if (this.pesoEditado) {
        this.form.pesoLiquido = newValue;
        this.form.pesoBruto = newValue;
      }
    },
  },
};
